import { http } from "../http/Http";
import { TimeZone } from "../models/TimeZone";
import { ServiceResponse } from "../models/ServiceResponse";

export class TimeZoneService {

    getTimeZones = async (): Promise<ServiceResponse<TimeZone[]>> => {
        const { data } = await http.get<ServiceResponse<TimeZone[]>>("TimeZone/GetAll");
        return data;
    };

}